// Small domain helpers for transaction views. Extracted from
// src/pages/transactions/view/TransactionView.tsx so they're consumable
// from peeks, list cells, edge functions, and tests without duplicating
// the semantics (waste_image vs cmr, transit CSV encoding, etc.).

/** Minimal file shape needed for document-type counting. */
interface DocumentTypedFile {
  document_type: string;
}

/**
 * Count transaction files by document type. Common usage on transaction
 * detail views shows e.g. `photoCount > 0 ? "{{n}} zdjęć" : ""`.
 */
export function countFilesByDocumentType(
  files: DocumentTypedFile[] | null | undefined,
  documentType: string,
): number {
  if (!files) return 0;
  return files.filter((f) => f.document_type === documentType).length;
}

/**
 * Pre-computed document-type counts shown on the TRANSPORT section header.
 * `waste_image` (photos) and `cmr` are the two ops-facing "paper trail"
 * indicators operators scan for before opening the DOCUMENTS tab.
 */
export interface TransactionDocStats {
  photoCount: number;
  cmrCount: number;
}

export function computeTransactionDocStats(
  files: DocumentTypedFile[] | null | undefined,
): TransactionDocStats {
  return {
    photoCount: countFilesByDocumentType(files, 'waste_image'),
    cmrCount: countFilesByDocumentType(files, 'cmr'),
  };
}

/**
 * The `transactions.transit` column stores EU country codes as a
 * comma-separated string ("CZ,DE"). FE edits it as a multiselect bound
 * to an options list. Use these helpers to convert in both directions
 * so the CSV encoding lives in one place.
 */
export function parseTransitCountries(csv: string | null | undefined): string[] | null {
  if (!csv) return null;
  const parts = csv.split(',').map((s) => s.trim()).filter(Boolean);
  return parts.length > 0 ? parts : null;
}

export function formatTransitCountries(codes: string[] | null | undefined): string | null {
  if (!codes || codes.length === 0) return null;
  return codes.join(',');
}
